import { render, staticRenderFns } from "./pondABWTab.vue?vue&type=template&id=21e99ca6&"
import script from "./pondABWTab.vue?vue&type=script&lang=js&"
export * from "./pondABWTab.vue?vue&type=script&lang=js&"
import style0 from "./pondABWTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports